const PORTAL_ROOT_ID = "react-portal-root";

export function getReactPortalRoot() {
  if (typeof document === "undefined") {
    return null;
  }

  let portalRoot = document.getElementById(PORTAL_ROOT_ID);
  if (!(portalRoot instanceof HTMLElement)) {
    portalRoot = document.createElement("div");
    portalRoot.id = PORTAL_ROOT_ID;
    document.body.appendChild(portalRoot);
  }

  return portalRoot;
}
